/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSaleManDtoAdmin } from '../models/CreateSaleManDtoAdmin';
import type { SaleManAdminDto } from '../models/SaleManAdminDto';
import type { UpdateSaleManDtoAdmin } from '../models/UpdateSaleManDtoAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SaleMenService {
    /**
     * **Required Policy:** `ViewSalesMen`
     * @returns SaleManAdminDto OK
     * @throws ApiError
     */
    public static getAllAdmin(): CancelablePromise<Array<SaleManAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/salemen',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSalesMen`
     * @returns SaleManAdminDto OK
     * @throws ApiError
     */
    public static createAdmin({
        requestBody,
    }: {
        requestBody?: CreateSaleManDtoAdmin,
    }): CancelablePromise<SaleManAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/salemen',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSalesManDetails`
     * @returns SaleManAdminDto OK
     * @throws ApiError
     */
    public static getByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<SaleManAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/salemen/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSalesMen`
     * @returns SaleManAdminDto OK
     * @throws ApiError
     */
    public static updateAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: UpdateSaleManDtoAdmin,
    }): CancelablePromise<SaleManAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/salemen/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteSalesMen`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/salemen/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
